import { CSS as AutoCompleteMenuCSS } from '../../components/autocomplete.menu/autocomplete.menu.style';
import { CSS as MenuItemCSS } from '../../components/menu/menu.item.style';

import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-TagInput',
	filterMatch: 'c-TagInput__match',
	link: 'c-TagInput__link',
	title: 'c-TagInput__title',
	date: 'c-TagInput__date',
	linkEditable: 'c-TagInput__link--editable',
};

export const Style = {
	[CSS.container]: {
		flex: '1 1',
		display: 'flex',
		position: 'relative',

		[`& .${AutoCompleteMenuCSS.container}`]: {
			position: 'absolute',
			top: '100%',
			left: '0',
		},
		[`& .${AutoCompleteMenuCSS.container} .${MenuItemCSS.item}`]: {
			overflow: 'hidden',
			display: ' inline-block',
			'text-overflow': 'ellipsis',
			'white-space': 'nowrap',
			'text-align': 'left',
		},
	},
	[CSS.date]: {
		color: DefaultTheme.font.color.disabled,
		'line-height': DefaultTheme.space(4),
		'font-size': '90%',
	},
	[CSS.title]: {
		'line-height': DefaultTheme.space(4),
	},
	[CSS.filterMatch]: {
		fontWeight: DefaultTheme.font.weight.bold,
	},
	[CSS.link]: {
		padding: `0 ${DefaultTheme.space(1)}`,
		flex: '1 1',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		textOverflow: 'ellipsis',
		cursor: 'pointer',
	},
	[CSS.linkEditable]: {
		extend: CSS.link,
		width: '100%',
		lineHeight: DefaultTheme.space(6),
		fontFamily: DefaultTheme.font.familyCondensed,
		fontSize: DefaultTheme.font.size,
		background: 'transparent',
		outline: 'none',
		border: 'none',
		borderBottom: `2px solid ${DefaultTheme.color.primary}`,
		cursor: 'text',
	},
};
